import { handleResponse, handleError } from './apiUtils';
let baseUrl = "https://benchmark-brian.herokuapp.com/api";
if (process.env.REACT_APP_DEV_BACKEND_PATH) {
    baseUrl = process.env.REACT_APP_DEV_BACKEND_PATH
}

export function getPosts() {
    return fetch(baseUrl)
        .then(handleResponse)
        .catch(handleError)
}

export function register(userData) {
    return fetch(baseUrl + '/register', {
        method: 'POST',
        headers: {
            'Content-type': 'application/json'
        },
        body: JSON.stringify(userData)
    })
        .then(handleResponse)
        .catch(handleError)
}

export function login(userData) {
    return fetch(baseUrl + '/login', {
        method: 'POST',
        headers: {
            'Content-type': 'application/json'
        },
        body: JSON.stringify(userData)
    })
        .then(handleResponse)
        .catch(handleError)
}

export function oauthLogin(userData) {
    return fetch(baseUrl + '/oauthLogin', {
        method: 'POST',
        headers: {
            'Content-type': 'application/json'
        },
        body: JSON.stringify(userData)
    })
        .then(handleResponse)
        .catch(handleError)
}

export function resetPassword(email) {
    return fetch(baseUrl + '/resetPassword', {
        method: 'PUT',
        headers: {
            'Content-type': 'application/json'
        },
        body: JSON.stringify(email)
    })
        .then(handleResponse)
        .catch(handleError)
}

export function getProfile(id) {
    return fetch(baseUrl + `/profile?id=${id}`)
        .then(handleResponse)
        .catch(handleError)
}